const state = {
  deviceName: '',
  deviceToken: ''
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/device/state.js